import {memo, useContext, useState} from 'react'
import { getImageUrl,getItemVal } from "../../Data/GeneralFanction";
import DataSet from "../DataSet/DataSet";
import { Routes, Route, Link } from 'react-router-dom';
import './Category.css'
import {  LanguageContext } from '../../context';
import { useQueryParam, StringParam } from 'use-query-params';

const Category = ({ category }) => {

  const { language } = useContext(LanguageContext);

  // const [categoryId,setCategoryId]=useState();
  const [categoryF, setCategoryF] = useQueryParam('categoryF', StringParam);

  
  return (
    
    <Link to={`/${language}?categoryF=${getItemVal("ID",category)}`} className="link-category" role="tab" aria-selected={getItemVal("ID",category)==categoryF}>
    <div className={getItemVal("ID",category)==categoryF?"innerCategory active":"innerCategory" }>  
    
     <img src={getImageUrl("image_url",category)} alt=''/>
      <p>{getItemVal(language=='he'?"Title":"Title_"+language,category)}</p>    
    </div>
    </Link>
 
  );
};

export default memo(Category) ;